<!--suppress AngularUndefinedTag -->
<ng-container *ngIf="taskPrintService.task">
  <table class="print-container">
    <thead class="print-header">
    <tr>
      <th>
        <h1>
          Overzicht taak {{ taskPrintService.task.number }}
          -
          {{ taskPrintService.task.created_at | date:'dd-MM-yy' }}
        </h1>
      </th>
    </tr>
    </thead>
    <tbody class="print-content">
    <tr>
      <td>
        <div class="content">
          <h2>Taak gegevens</h2>
          <table style="width:100%">
            <tr>
              <td style="width:50%">
                <table style="width:100%">
                  <tr>
                    <th style="width:40%">Taaknummer:</th>
                    <td style="width:60%">{{ taskPrintService.task.number }}</td>
                  </tr>
                  <tr>
                    <th>Startdatum & tijd:</th>
                    <td>{{ taskPrintService.task.created_at | date:'dd-MM-yy HH:mm' }}</td>
                  </tr>
                  <tr>
                    <th>Einddatum & tijd:</th>
                    <td>{{ taskPrintService.task.closed_at | date:'dd-MM-yy HH:mm' }}</td>
                  </tr>
                  <tr>
                    <th>Prioriteit:</th>
                    <td>{{ taskPrintService.task.priority?.display_name }}</td>
                  </tr>
                  <tr>
                    <th>Status:</th>
                    <td>{{ taskPrintService.task.status?.display_name }}</td>
                  </tr>
                  <tr>
                    <th>Toegekend aan:</th>
                    <td>{{ taskPrintService.task.assigned_user?.name }}</td>
                  </tr>
                  <tr>
                    <th>Tegel:</th>
                    <td>{{ taskPrintService.task.tile?.name }}</td>
                  </tr>
                  <tr>
                    <th>Coördinaten:</th>
                    <td>X: {{ taskPrintService.task.new_rd_lat }}, Y: {{ taskPrintService.task.new_rd_lng }}</td>
                  </tr>
                  <tr>
                    <th>Adres:</th>
                    <td>{{ taskPrintService.task.streetname }} {{ taskPrintService.task.house_number }}{{ taskPrintService.task.house_number_addition }}, {{ taskPrintService.task.city }}</td>
                  </tr>
                  <tr>
                    <th>Basis registratie:</th>
                    <td>{{ taskPrintService.task.basic_registration?.name }}</td>
                  </tr>
                  <tr>
                    <th>Taak:</th>
                    <td>{{ taskPrintService.task.task_registration?.name }}</td>
                  </tr>
                  <tr>
                    <th>Bron:</th>
                    <td>{{ taskPrintService.task.source?.name }}</td>
                  </tr>
                  <tr>
                    <th>Actie:</th>
                    <td>{{ taskPrintService.task.action?.name }}</td>
                  </tr>
                  <tr>
                    <th>Stroom:</th>
                    <td>{{ taskPrintService.task.current?.name }}</td>
                  </tr>
                  <tr>
                    <th>Invloed registraties:</th>
                    <td>{{ taskPrintService.task.impact_registration?.name }}</td>
                  </tr>
                  <tr>
                    <th>Zaak:</th>
                    <td>{{ taskPrintService.task.outside_number }}</td>
                  </tr>
                </table>
              </td>
              <td style="width:50%">
                <table style="width:100%">
                  <tr *ngIf="taskPrintService.task.reopen_notes?.length">
                    <th>Verklaring taak heropenen:</th>
                    <td>
                      <div *ngFor="let note of taskPrintService.task.reopen_notes" class="note-container">
                        <h3 class="note-header">
                          {{ note.created_at | date:'dd-MM-yy HH:mm' }}
                          <ng-container *ngIf="note.user">{{ note.user.name }}</ng-container>
                          <ng-container *ngIf="!note.user">Onbekend</ng-container>
                        </h3>
                        <div [innerHTML]="note.note" class="note-content"></div>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="taskPrintService.task.reassign_notes?.length">
                    <th>Nieuw toegewezen taak:</th>
                    <td>
                      <div *ngFor="let note of taskPrintService.task.reassign_notes" class="note-container">
                        <h3 class="note-header">
                          {{ note.created_at | date:'dd-MM-yy HH:mm' }}
                          <ng-container *ngIf="note.user">{{ note.user.name }}</ng-container>
                          <ng-container *ngIf="!note.user">Onbekend</ng-container>
                        </h3>
                        <div [innerHTML]="note.note" class="note-content"></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>Afhandeling notities:</th>
                    <td>
                      <ng-container *ngIf="taskPrintService.task.notes?.length">
                        <div *ngFor="let note of taskPrintService.task.notes" class="note-container">
                          <h3 class="note-header">
                            {{ note.created_at | date:'dd-MM-yy HH:mm' }}
                            <ng-container *ngIf="note.user">{{ note.user.name }}</ng-container>
                            <ng-container *ngIf="!note.user">Onbekend</ng-container>
                            <small *ngIf="note.is_updated"> (aangepast)</small>
                          </h3>
                          <div [innerHTML]="note.note" class="note-content"></div>
                        </div>
                      </ng-container>
                    </td>
                  </tr>
                  <tr *ngIf="taskPrintService.task.handling?.attachments?.total">
                    <th>Afhandeling bijlagen:</th>
                    <td>
                      <ng-container *ngIf="!taskPrintService.task.handling?.attachments?.total">
                        Geen bijlagen
                      </ng-container>
                      <ng-container *ngIf="taskPrintService.task.handling?.attachments?.total">
                        <div *ngIf="taskPrintService.task.handling?.attachments.media.length" class="media">
                          <div *ngFor="let photo of taskPrintService.task.handling?.attachments.media; let i = index"
                               class="media-div">
                            <img *ngIf="photo.type === 'image'" [src]="photo.src" alt="">
                            <video *ngIf="photo.type === 'video'" [src]="photo.src"></video>
                          </div>
                          <div *ngIf="taskPrintService.task.handling?.attachments.documents.length">
                            <ng-container *ngFor="let document of taskPrintService.task.handling?.attachments.documents">
                              <ng-container *ngIf="document.type === 'document'">
                                {{ document.original_filename }}<br>
                              </ng-container>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</ng-container>
